// Single source of truth for the customer-facing refund policy body.
// Rendered in two places — TermsPage section 7 and the standalone
// /refund-policy page. If you change the wording, bump
// TERMS_CONSENT_VERSION in src/constants/termsConsent.js (and the
// matching server constant) so old consent records stay tied to the
// wording they actually agreed to.

export default function RefundPolicy() {
  return (
    <div className="text-gray-600 space-y-4">
      <p>
        Identity verification is a digital service that is performed in full the moment your verification checks complete. By ticking the consent box at checkout, you asked us to begin the service immediately and confirmed that your 14-day right to cancel under the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 ends once the service has been fully performed.
      </p>
      <p>
        Once your verification is complete the fee is non-refundable.
      </p>

      <p className="font-medium text-gray-900 mt-6">Exceptions</p>
      <ul className="list-disc list-inside space-y-2">
        <li>
          <strong>You abandon verification before completing it:</strong> contact <a href="mailto:info@taxstats.co.uk" className="text-blue-600 hover:underline">info@taxstats.co.uk</a> within 14 days of payment. We will refund the portion attributable to work not yet performed, at our discretion.
        </li>
        <li>
          <strong>Verification fails because of a fault attributable to TaxStats Ltd</strong> (a technical error or a regulatory mistake on our side): we will refund in full.
        </li>
        <li>
          <strong>Bundle orders (verification plus Confirmation Statement filing):</strong> the unfiled CS01 portion is refundable until the CS01 has been submitted to Companies House.
        </li>
      </ul>

      <p className="mt-6">
        This policy does not affect your statutory rights as a consumer where those rights cannot be waived by law.
      </p>
    </div>
  );
}
